import Widget from 'gatsby-plugin-pricespider/Widget';
import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React from 'react';
import { getPageType } from 'src/common/functions';
import { generateButtonClassName } from 'src/components/button/CmsButton';
import { CMS_THEME } from '../../common/enums';

interface PricespiderButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  cmsTheme?: CMS_THEME;
  outlined?: boolean;
  widgetID?: string | null;
  id?: string;
  skipAnalytics?: boolean;
}

const PricespiderWidget = function ({
  cmsTheme = CMS_THEME.LIGHT,
  outlined = false,
  widgetID = null,
  skipAnalytics,
  id = '',
  title,
  ...rest
}: PricespiderButtonProps) {
  const { className } = rest;

  if (!id) return null;

  const styledWidget = (
    <Widget
      className={generateButtonClassName({
        cmsTheme,
        variant: outlined ? 'btn-outline' : 'btn',
        className: [className, 'pds-text-center pds-no-underline'],
      })}
      id={id}
      sku={id}
      widgetID={widgetID}
      aria-describedby={id}
    />
  );

  if (skipAnalytics) {
    return styledWidget;
  }

  return (
    // we don't care about accessibility here since we
    // are just taking advantage of event caputring
    // eslint-disable-next-line
    <div
      onClickCapture={() => {
        sendIt({
          event: 'module_interaction',
          eventParams: {
            component_type: 'link_button',
            component_id: 'buy_now_button',
            content_name: `${getPageType(true)}_buy_now_button`,
            page_type: getPageType(true),
            product_name: title,
          },
        });
      }}
      onKeyDownCapture={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          sendIt({
            event: 'module_interaction',
            eventParams: {
              component_type: 'link_button',
              component_id: 'buy_now_button',
              content_name: `${getPageType(true)}_buy_now_button`,
              page_type: getPageType(true),
              product_name: title,
            },
          });
        }
      }}
    >
      {styledWidget}
    </div>
  );
};

export default PricespiderWidget;
